import React, { useState } from "react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { ImageUpload } from "@/components/ImageUpload";

export const RestaurantSettings = () => {
  const { restaurant, refresh } = useAuth();
  const [form, setForm] = useState({
    name: restaurant?.name || "",
    logo_url: restaurant?.logo_url || "",
    address: restaurant?.address || "",
    contact_number: restaurant?.contact_number || "",
    whatsapp_number: restaurant?.whatsapp_number || "",
    google_review_link: restaurant?.google_review_link || "",
  });
  const [pwd, setPwd] = useState("");

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.patch("/restaurant/settings", form);
      toast.success("Settings saved");
      refresh();
    } catch (err) { toast.error(formatErr(err)); }
  };

  const changePwd = async () => {
    if (!pwd) return;
    try {
      await api.post("/restaurant/change-password", { new_password: pwd });
      toast.success("Password changed");
      setPwd("");
    } catch (err) { toast.error(formatErr(err)); }
  };

  return (
    <div data-testid="rest-settings">
      <h1 className="text-2xl font-bold">Settings</h1>
      <p className="text-sm text-zq-muted mt-1">Update your restaurant info and password.</p>

      <form className="zq-card p-6 mt-6 grid sm:grid-cols-2 gap-3" onSubmit={save}>
        <div className="sm:col-span-2">
          <label className="text-xs font-medium text-zq-muted">Restaurant Name</label>
          <input className="zq-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="set-name"/>
        </div>
        <div className="sm:col-span-2">
          <label className="text-xs font-medium text-zq-muted">Address</label>
          <input className="zq-input" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} data-testid="set-address"/>
        </div>
        <div>
          <label className="text-xs font-medium text-zq-muted">Contact Number</label>
          <input className="zq-input" value={form.contact_number} onChange={(e) => setForm({ ...form, contact_number: e.target.value })} data-testid="set-contact"/>
        </div>
        <div>
          <label className="text-xs font-medium text-zq-muted">WhatsApp Number</label>
          <input className="zq-input" value={form.whatsapp_number} onChange={(e) => setForm({ ...form, whatsapp_number: e.target.value })} data-testid="set-whatsapp"/>
        </div>
        <div className="sm:col-span-2">
          <ImageUpload
            value={form.logo_url}
            onChange={(url) => setForm({ ...form, logo_url: url })}
            folder={`zaykaqr/restaurants/${restaurant?.id}/logo`}
            label="Restaurant Logo"
            aspect="aspect-[3/1]"
            testId="settings-logo-upload"
          />
        </div>
        <div className="sm:col-span-2">
          <label className="text-xs font-medium text-zq-muted">Google Review Link</label>
          <input className="zq-input" value={form.google_review_link} onChange={(e) => setForm({ ...form, google_review_link: e.target.value })}/>
        </div>
        <div className="sm:col-span-2">
          <button className="zq-btn zq-btn-primary" data-testid="set-save">Save changes</button>
        </div>
      </form>

      <div className="zq-card p-6 mt-6">
        <h3 className="font-semibold">Change password</h3>
        <div className="flex gap-2 mt-3">
          <input className="zq-input flex-1" type="password" placeholder="New password" value={pwd} onChange={(e) => setPwd(e.target.value)} data-testid="change-pwd-input"/>
          <button className="zq-btn zq-btn-primary" onClick={changePwd} data-testid="change-pwd-btn">Update</button>
        </div>
      </div>
    </div>
  );
};
